import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const AddBazarWork = () => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [date, setDate] = useState('');
    const [images, setImages] = useState([]);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Set today's date as default value for the date input
    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        setDate(formattedDate); // Set today's date to the state
    }, []);

    // Handle form submit
    const handleSubmit = (e) => {
        e.preventDefault();

        // Validation for empty fields
        if (!title || !description || !date || images.length === 0) {
            setError('All fields are required!');
            return;
        }

        // Prepare the data to send in the POST request
        const newBazarWork = {
            title,
            description,
            date,
            images,
        };

        // Make the POST request to the API
        fetch(`${BASE_URL}bazarworks`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(newBazarWork),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
Swal.fire({
  icon: "success",
  title: "Bazar work added successfully",
});                    navigate('/BazarList');  // Redirect to the list page after success
                } else {
                    setError(data.message || 'Failed to add bazar work.');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setError('There was an error adding the bazar work.');
            });
    };

    // Handle file input change for images
    const handleImageChange = (e) => {
        setImages([...e.target.files]);
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Bazar Work</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add Bazar Work</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="title" className="form-label">Title</label>
                                        <input
                                            type="text"
                                            id="title"
                                            className="form-control"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3 d-none">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="images" className="form-label">Images</label>
                                        <input
                                            type="file"
                                            id="images"
                                            className="form-control"
                                            multiple
                                            onChange={handleImageChange}
                                            required
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Add Bazar Work</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddBazarWork;
